import React from "react";
import { useSelector } from "react-redux";
import extractIdFromGid from "helpers/extract-gid";
import useModal from "hooks/useModal";
import ProductItem from "components/product/item";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow-sub.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow-sub.svg";
import clsx from "clsx/lite";

const SubscriptionProducts = ({ allProducts, isSlider = true, hideATCPrice = false, sliderProps = {}, className = "" }) => {
	const [modal, openModal, closeModal] = useModal("product");
	const { isActive, lines } = useSelector((state) => state.account.subscription);

	if (!allProducts?.length) return null;

	const contractLineItems = lines ?? [];

	let contractProducts = [];

	if (allProducts?.length > 0) {
		contractProducts = allProducts.flatMap((product) => {
			const contractLineItem = contractLineItems[extractIdFromGid(product.variant.id)];

			if (!contractLineItem?.quantity) return [];

			const discountedPrice = contractLineItem.discountedPrice;

			const mappedProducts = [{
				...product,
				index: contractLineItem.index,
				variant: {
					...product.variant,
					discountedPrice: discountedPrice,
					isOneTimeAdded: contractLineItem?.isOneTimeAdded,
				},
			}];

			if (contractLineItem.duplicates) {
				contractLineItem.duplicates.forEach(duplicate => {
					if (duplicate.discountedPrice !== discountedPrice && (duplicate.discountedPrice === 0 || discountedPrice === 0)) {
						mappedProducts.push({
							...product,
							id: `${product.id}-gift`,
							variant: {
								...product.variant,
								discountedPrice: duplicate.discountedPrice,
								isOneTimeAdded: duplicate?.isOneTimeAdded,
							},
						});
					}
				});
			}

			return mappedProducts;
		});
	}

	contractProducts.sort((a, b) => a?.index - b?.index);

	if (!contractProducts?.length) return null;

	if (isSlider) {
		const settings = {
			slidesPerView: 1,
			preventClicks: true,
			preventClicksPropagation: false,
			noSwiping: true,
			freeMode: true,
			spaceBetween: 20,
			centerInsufficientSlides: true,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			slidesPerGroup: 1,
			navigation: {
				enabled: true,
				nextEl: ".right-arrow-es",
				prevEl: ".left-arrow-es",
			},
			a11y: true,
			breakpoints: {
				700: {
					slidesPerView: 3,
				},
				992: {
					slidesPerView: 5,
					spaceBetween: 30,
				},
			},
			...sliderProps,
		};

		return (
			<div className={clsx("relative mb-10 md:mb-5", isSlider && "md:px-10 lg:w-90 lg:mx-auto", !isActive && "mt-10", className)}>
				<div className="w-full mx-auto">
					<div className="flex flex-wrap justify-center">
						<Swiper {...settings} className="w-full">
							{contractProducts?.map((item, index) => (
								<SwiperSlide key={`${item.id}${index}`}>
									<ProductItem
										product={{ ...item, index }}
										isOpen={modal[extractIdFromGid(item.id)]}
										openModal={() => openModal(extractIdFromGid(item.id))}
										closeModal={() => closeModal(extractIdFromGid(item.id))}
										newLayout
										hideATCPrice={hideATCPrice}
									/>
								</SwiperSlide>
							))}

						</Swiper>
					</div>
					<div className="left-arrow-es"><LeftArrow role="presentation" aria-hidden="true" /></div>
					<div className="right-arrow-es"><RightArrow role="presentation" aria-hidden="true" /></div>
				</div>
			</div>
		);
	}

	return (
		<div className={clsx("relative mb-10 md:mb-5", !isActive && "mt-10", className)}>
			<div className="flex flex-wrap justify-center">
				{contractProducts?.map((item, index) => (
					<div id={item.id} key={`${item.id}${index}`} className="w-full mx-[1%] md:w-[30%] lg:w-[22%] mb-10 lg:mx-2">
						<ProductItem
							product={{ ...item, index }}
							isOpen={modal[extractIdFromGid(item.id)]}
							openModal={() => openModal(extractIdFromGid(item.id))}
							closeModal={() => closeModal(extractIdFromGid(item.id))}
							newLayout
							hideATCPrice={hideATCPrice}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default SubscriptionProducts;